/* @flow */
import React, { forwardRef } from 'react';
import classnames from 'classnames';
import type { InputType } from './InputType';

const Input: React.ForwardRefRenderFunction<InputType, HTMLInputElement> =
  forwardRef((props: InputType, ref) => {
    const {
      type = 'text',
      invalid,
      descriptionId,
      labelId,
      errorId,
      classNames,
      name,
      id,
      ...rest
    } = props;

    const attributes = {
      'aria-invalid': invalid && 'true',
      'aria-describedby': descriptionId,
      'aria-labelledby': labelId,
      'aria-errormessage': errorId,
      type,
      name,
      id: id || name,
    };
    const textarea = 'textarea';
    const inputClassNames = classnames(
      'input',
      type === textarea && textarea,
      classNames
    );
    const HtmlTag = type === textarea ? textarea : 'input';

    return (
      <HtmlTag
        {...rest}
        className={inputClassNames}
        {...attributes}
        ref={ref}
      />
    );
  });

Input.displayName = 'Input';

export default Input;
